module.exports = __webpack_public_path__ + "static/media/ensaladasyaderezos_checked.3357ee29.svg";